/* @flow */
import React, { Component, useState } from "react";
import styled, { css } from "styled-components";
import ClickOutside from "../common/ClickOutside";
import User from "./User";
import Menu from "./Menu";

import type { Profile } from "../../redux/CommonTypes";
import withErrorCatch from "../withErrorCatch";

const Container = React.memo(styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  align-content: stretch;
  justify-content: flex-start;
  min-width: 276px;
  max-width: 276px;
  background-color: ${props => props.theme.mainDark};
  z-index: 100000;
  cursor: default;
  transform: translateX(0);
  transition: transform 0.3s;

  ${props =>
    props.trade &&
    css`
      top: 74px;
      max-height: 100%;
    `};

  ${props =>
    !props.open &&
    css`
      transform: ${window.innerWidth < 960
        ? "translateX(-100%)"
        : "translateX(100%)"};
    `};

  @media (max-width: 959px) {
    top: 0;
    left: 0;
  }
`);

const Overlay = React.memo(styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  overflow: hidden;
  opacity: 1;
  transition: 0.3s;

  @media (max-width: 959px) {
    cursor: pointer;
  }

  ${props =>
    !props.open &&
    css`
      opacity: 0;
      z-index: -1;
    `};

  ${props =>
    props.trade &&
    css`
      background-color: ${({ overflow }) =>
        overflow ? "rgba(0, 0, 0, 0.5)" : "transparent"};

      @media (max-width: 959px) {
        background-color: rgba(0, 0, 0, 0.5);
      }
    `};
`);

type Props = {
  profile: Profile,
  isVIP: boolean,
  changeLocaleFetching: boolean,
  className?: string,
  trade?: boolean,
  style: string | number,
  hideLangSelect?: boolean,
  onClose: () => void,
  onLocaleChange: (value: string) => void
};

class CommonNav extends Component<Props, {}> {
  render() {
    const {
      className,
      onClose,
      trade,
      profile,
      isVIP,
      hideLangSelect,
      open,
      bellActive,
      setBellActive
    } = this.props;

    return (
      <ClickOutside onOutsideClick={onClose}>
        {({ innerRef }) => (
          // обычный ref для стильного компонента отдает не элемент DOMа,
          // поэтому для элемента DOMа нам нужен innerRef
          <Container
            ref={innerRef}
            className={className}
            trade={trade}
            open={open}
          >
            {profile && (
              <User
                {...profile}
                trade={trade}
                onClick={onClose}
                isVIP={isVIP}
                changeLocaleFetching={this.props.changeLocaleFetching}
                onLocaleChange={this.props.onLocaleChange}
                hideLangSelect={hideLangSelect}
              />
            )}
            <Menu
              locale={profile ? profile.locale : null}
              currency={profile ? profile.currency : null}
              changeLocaleFetching={this.props.changeLocaleFetching}
              onLocaleChange={this.props.onLocaleChange}
              onClick={onClose}
              isLoggedIn={!!profile}
              hideLangSelect={hideLangSelect}
              bellActive={bellActive}
              onBellClick={setBellActive}
              isRealAcc={Boolean(profile && profile.real && profile.real === 1)}
            />
          </Container>
        )}
      </ClickOutside>
    );
  }
}

const Navigation = React.memo((props: Props) => {
  const [bellActive, setBellActive] = useState(false);
  return (
    <Overlay trade={props.trade} open={props.open} overflow={bellActive}>
      <CommonNav
        {...props}
        setBellActive={setBellActive}
        bellActive={bellActive}
      />
    </Overlay>
  );
});

export default withErrorCatch(Navigation);



// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.js